import React from 'react';
import { forNamespace, forTemplate } from 'app/common/lib/util/i18n';
import { UpgradePromptPill } from 'app/src/components/UpgradePrompts';
import { IconName } from 'app/common/components/controls';
import { trackUe, Verb, Noun } from '@trello/analytics';
const formatTemplate = forTemplate('card_detail');
const formatPrompt = forNamespace('upgrade prompt');

export const PupUpgradePromptSection: React.FunctionComponent<{
  upgradeUrl: string;
}> = ({ upgradeUrl }) => (
  <div className="card-back-pup-upgrade-prompt-section">
    <div className="card-back-pup-upgrade-prompt-opener">
      {formatTemplate('upgrade-to-get-unlimited-power-ups-2')}
    </div>
    <div className="card-back-pup-upgrade-prompt">
      <UpgradePromptPill
        iconName={IconName.BusinessClass}
        cta={formatPrompt('upgrade team')}
        ctaLink={upgradeUrl}
        ctaOnClick={() =>
          trackUe(
            Noun.CARD_BACK,
            Verb.OPENS,
            Noun.TEAM_PAGE_BC_TAB,
            '',
            '',
            'by clicking pill upgrade prompt in card back pup section',
          )
        }
      />
    </div>
  </div>
);
